var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9899_4368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path894",
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9899_4368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path900",
    d: "M16.9036 3.09637H16.903C16.2101 3.09637 15.6484 3.65809 15.6484 4.35094M15.6484 4.35094V4.35156M15.6484 4.35094C15.6484 3.65809 15.0867 3.09637 14.3938 3.09637H14.3932",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path904",
    d: "M16.9036 16.9038H16.903C16.2101 16.9038 15.6484 16.3421 15.6484 15.6492V15.6486C15.6484 16.3418 15.0864 16.9038 14.3932 16.9038",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path908",
    d: "M15.6484 15.6484V4.35156",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path912",
    d: "M19.4141 6.86231C19.4141 6.52938 19.282 6.21023 19.0463 5.97488C18.8109 5.73922 18.4918 5.60711 18.1588 5.60711H1.84113C1.5082 5.60711 1.18906 5.73922 0.953711 5.97488C0.718047 6.21023 0.585938 6.52938 0.585938 6.86231V13.1384C0.585938 13.4713 0.718047 13.7904 0.953711 14.0258C1.18906 14.2614 1.5082 14.3936 1.84113 14.3936H18.1588C18.4918 14.3936 18.8109 14.2614 19.0463 14.0258C19.282 13.7904 19.4141 13.4713 19.4141 13.1384V6.86231Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename-icon.86f78b58488bdbe4c0cfa4082c7cf0f5.svg";
export { ForwardRef as ReactComponent };